import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import { toLower } from 'lodash';
import {
  StyledNotificationDirectory,
  StyledNotificationActions,
  StyledNotificationDate,
  StyledNotificationType,
  StyledNotificationTitle,
  StyledEmployerTableCell,
  StyledIcon,
  StyledIconDot,
  StyledRoundedIcon,
  StyledWrapperFlex,
  StyledNotificationWidget,
  StyledImg
} from './style';

import { Trash, Razor, Eye } from '../../../../assets/images/index';
import {
  checkViewedByContent,
  deleteNotificationById,
  getImageFromNotification
} from '../../../utils/apiHeader';
import { API } from '../../../constants/api';

const notificationsTypes = {
  NEWS: 'Noticia',
  EVENT: 'Evento',
  NEWSREVIEW: 'Resumen de Prensa'
};

// const typeAppNotification = {
// CMS: 'General',
// PARCEL: 'Paquetería',
// TRAVEL: 'Viaje',
// EVENT: 'Evento'
// };

const urlEnv =
  process.env.NODE_ENV === 'production'
    ? 'https://a3mil.atresmedia.com'
    : 'https://a3milpre.atresmedia.com';

const RowNotifications = ({ item, isWidget, history, onDelete }) => {
  const [image, setImage] = useState(null);
  useEffect(() => {
    if (isWidget) {
      getImageFromNotification(item?.idNotification).then(image =>
        setImage(image)
      );
    }
  }, []);
  const onClickNotification = type => {
    if (type === 'widget') {
      if (item) {
        let notType =
          item?.contentType === 'NEWSREVIEW'
            ? 'Resumen_Prensa'
            : notificationsTypes[item?.contentType];
        if (notType === 'Evento') {
          notType = 'Agenda';
        }
        const url = `${urlEnv}/${toLower(notType)}/${item?.contentId}`;
        checkViewedByContent(item?.contentId).then(() => {
          window.open(url, '_blank', 'noopener,noreferrer');
          onDelete(item?.idNotification);
        });
      }
    } else if (type === 'view') {
      if (item) {
        let notType =
          item?.contentType === 'NEWSREVIEW'
            ? 'Resumen_Prensa'
            : notificationsTypes[item?.contentType];
        if (notType === 'Evento') {
          notType = 'Agenda';
        }
        const url = `${toLower(notType)}/${item?.contentId}`;
        checkViewedByContent(item?.contentId).then(() => {
          history.push(url);
        });
      }
    } else if (type === 'delete') {
      deleteNotificationById(item?.idNotification).then(() => {
        onDelete(item?.idNotification);
      });
    }
  };

  const getImageNotification = () => {
    let res = null;
    if (image && image.path !== '') {
      const path = `${API}${image.path}`;
      res = <StyledImg src={path} isWidget={isWidget} />;
    } else {
      res = <StyledIcon isWidget={isWidget} svg={Razor} />;
    }
    return <StyledRoundedIcon>{res}</StyledRoundedIcon>;
  };

  const StyledNotificationWrapper = ({ children }) =>
    isWidget ? (
      <StyledNotificationWidget
        viewed={item.viewed}
        onClick={() => onClickNotification('widget')}
      >
        {children}
      </StyledNotificationWidget>
    ) : (
      <StyledNotificationDirectory viewed={item.viewed}>
        {children}
      </StyledNotificationDirectory>
    );

  return (
    <StyledNotificationWrapper>
      {!isWidget && <StyledIconDot viewed={item.viewed} />}
      {!isWidget && (
        <StyledNotificationDate isWidget={isWidget}>
          {moment(item.sendDate).format('DD/MM/YYYY')}
        </StyledNotificationDate>
      )}
      {/* !isWidget && (
        <StyledNotificationType>
          {typeAppNotification[item.typeAppNotification]}
        </StyledNotificationType>
      ) */}
      {!isWidget && (
        <StyledNotificationType>
          {notificationsTypes[item.contentType]}
        </StyledNotificationType>
      )}
      {isWidget && getImageNotification()}
      <StyledNotificationTitle isWidget={isWidget} title={item.title}>
        {item.title}
      </StyledNotificationTitle>
      {!isWidget && (
        <StyledWrapperFlex>
          <StyledNotificationActions>
            <StyledEmployerTableCell>
              <StyledIcon
                svg={Eye}
                size="m"
                profilee="button"
                hover
                onClick={() => onClickNotification('view')}
              />
            </StyledEmployerTableCell>
            <StyledEmployerTableCell>
              <StyledIcon
                svg={Trash}
                size="m"
                profilee="button"
                hover
                onClick={() => onClickNotification('delete')}
              />
            </StyledEmployerTableCell>
          </StyledNotificationActions>
        </StyledWrapperFlex>
      )}
    </StyledNotificationWrapper>
  );
};

RowNotifications.propTypes = {
  item: PropTypes.shape({
    userId: PropTypes.number,
    title: PropTypes.string,
    viewed: PropTypes.bool,
    dateCreateNotUser: PropTypes.string,
    typeAppNotification: PropTypes.string,
    contentType: PropTypes.string,
    contentId: PropTypes.number
  })
};

export default withRouter(RowNotifications);
